import Service from "../Service";

const resource = "ExtCommercialCapacityConfig/";

export default {
  list(filter, requestID) {
    return Service.post(resource + "list", filter, {
      params: { requestID: requestID },
    });
  },

  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID: requestID },
    });
  },
};
